import React from "react";
import { Accordion } from '@prosolve/common-components-ui'
import BarChart from "./BarChart";
import TextAnswersGrid from "./TextAnswersGrid";

export default ({
  feedbackData = {}
}) => {

  const { 
    counts = {},
    questions = []
  } = feedbackData;

  const hasCounts = Object.keys(counts).length > 0;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
    }}>
      {
        hasCounts ?
        questions.map(questionObj => {
          const {
            id,
            question = '',
            category = '',
          } = questionObj;

          const questionDisplay = `${category ? `${category}: ` : ''}${question}`;

          const currentQuestionCounts = counts[id]; 

          return (
            <Accordion
              key={id}
              title={<div style={{ color: '#565656', fontSize: '18px', fontWeight: 'bold' }}>{questionDisplay}</div>}
              defaultOpen={true}
              headerExpands={true}
              style={{ padding: '20px 15px 20px 5px' }}
              expandedStyle={{ padding: '0px 0px 10px 0px' }}
            >
              {
                Array.isArray(currentQuestionCounts) ?
                  <TextAnswersGrid answers={currentQuestionCounts} />
                  :
                  <BarChart currentQuestionDataObj={questionObj} currentQuestionCounts={currentQuestionCounts} />
              }
              {/* <BarChart currentQuestionDataObj={questionObj} currentQuestionCounts={currentQuestionCounts} /> */}
            </Accordion>
          )
        })
        :
        <div style={{
          color: '#565656', 
          fontSize: '15px'
        }}>
          {'No questions found with responses'}
        </div>
      }
    </div>
  )
}